var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 61,
    viewBox: "0 0 114 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.995 58.772c24.158 0 44.914-11.679 53.995-28.386C101.909 13.679 81.153 2 56.995 2 32.838 2 12.08 13.679 3 30.386c9.081 16.707 29.838 28.386 53.995 28.386z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.175 30.628c0 13.717-11.12 24.837-24.838 24.837-13.717 0-24.837-11.12-24.837-24.837 0-13.716 11.12-24.835 24.837-24.835 13.718 0 24.838 11.12 24.838 24.835z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.329 30.413c0 7.408-6.006 13.414-13.415 13.414-7.408 0-13.414-6.006-13.414-13.414C43.5 23.006 49.506 17 56.914 17c7.409 0 13.415 6.006 13.415 13.413",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFooter);
export default __webpack_public_path__ + "static/media/eyeFooter.e52a2101b7cc04f7ab3c5cbb1482eb49.svg";
export { ForwardRef as ReactComponent };